<template>
  <div id="app">
    <!-- 背景 -->
    <router-view />
  </div>
</template>

<script>
import cookies from 'js-cookie'
export default {
  name: 'App',
  created() {
    if (process.env.NODE_ENV === 'development') {
      cookies.set('USER_TOKEN', 'bfa2bc9055f247168390e167fb8c323f')
    }
  }
}
</script>
